import { DateTime } from 'luxon'
import {
  standardLabraDateFormat,
  standardLabraTimeFormat,
  standardLabraDateFormatOptions,
  standardLabraTimeFormatOptions,
} from '@labrav/common'

export const getDateDiff = (date: string) => {
  const dayDiff = Math.ceil(
    DateTime.fromISO(date).diff(DateTime.now(), 'days').days
  )
  const hrsDiff = Math.ceil(
    DateTime.fromISO(date).diff(DateTime.now(), 'hours').hours
  )
  const monthsDiff = Math.ceil(
    DateTime.fromISO(date).diff(DateTime.now(), 'months').months
  )

  return {
    dayDiff,
    hrsDiff,
    monthsDiff,
  }
}

export const getExpirationFromDate = (
  date: string,
  daysToCompare = 90,
  daysLessLimit = 15
) => {
  const { dayDiff, hrsDiff, monthsDiff } = getDateDiff(date)
  const isOneDayLeft = dayDiff > 0 && dayDiff <= 1
  const isLessThanOneDayLeft = dayDiff > 0 && dayDiff < 1
  const isExpriringSoon = dayDiff > 0 && dayDiff <= daysToCompare
  const isLessThanOneMonthLeft = dayDiff > 0 && monthsDiff <= 1
  const isLessThanGivenDay = dayDiff > 0 && dayDiff <= daysLessLimit
  const isExpired = dayDiff < 0 && dayDiff <= daysToCompare
  return {
    dayDiff,
    hrsDiff,
    monthsDiff,
    isOneDayLeft,
    isLessThanOneDayLeft,
    isExpriringSoon,
    isLessThanOneMonthLeft,
    isLessThanGivenDay,
    isExpired,
  }
}

export const getFormattedLabraDate = (date: string) => {
  const formattedDate = DateTime.fromISO(date).toFormat(standardLabraDateFormat)
  const formattedTime = DateTime.fromISO(date).toFormat(standardLabraTimeFormat)
  return {
    formattedDate,
    formattedTime,
  }
}

export const getLocalDateTime = (dateStr: string) => {
  try {
    const date = new Date(dateStr)
    const formattedDate = Intl.DateTimeFormat(
      'en-US',
      standardLabraDateFormatOptions as Intl.DateTimeFormatOptions
    ).format(date)
    const formattedTime = Intl.DateTimeFormat(
      'en-US',
      standardLabraTimeFormatOptions as Intl.DateTimeFormatOptions
    )
      .format(date)
      .replace('GMT', 'UTC')
    return {
      formattedDate,
      formattedTime,
    }
  } catch {
    return { formattedDate: '-', formattedTime: '-' }
  }
}

export const getSinceTime = (date?: string) => {
  if (!date) return ''
  const dateDiff = DateTime.now().diff(DateTime.fromISO(date), [
    'minutes',
    'seconds',
  ])
  const minuteDiff = Math.ceil(dateDiff.minutes)
  const secondDiff = Math.ceil(dateDiff.seconds)
  return `since ${minuteDiff} minute ${secondDiff} seconds.`
}
